import Button from '@/components/shared/Button';
import Link from '@/components/shared/Link';
import { useSetSelectedServiceValueFormState } from '@/atoms/form/selected-service-value-form-state';
import { useSetFeedbackPopupDataNameState } from '@/components/general/FeedbackPopup/use-feedback-popup-data-name-atom';
import { FEEDBACK_POPUP_NAME } from '@/components/general/FeedbackPopup/FeedbackPopup';
import { useSetOpenedPopupsState } from '@/atoms/opened-popups';
import { YD_NEW_ID } from '@/metrics/ym';
import { FAVORITES_POPUP_NAME } from '@/components/shared/FavoritesPopup/FavoritesPopup';
import CurrencyDropdown from '@/components/shared/CurrencyDropdown';
import { useNavProductDataState } from '@/atoms/product-nav-state';
import { toCurrency } from '@/utils/to-currency';
import { useRoubleToDollarCourseState } from '@/atoms/rouble-to-dollar-course';
import { useSetSelectedItemsState } from '@/atoms/form/selected-items-state';
import SortSVG from '@/svg/sort.svg?url';
import { SORT_POPUP_NAME } from '@/components/layout/CatalogFilters/SortPopup';
import FilterSVG from '@/svg/filter.svg?url';
import { FILTERS_POPUP_NAME } from '@/components/layout/CatalogFilters/FiltersPopup';
import { useEuroToDollarCourseState } from '@/atoms/euro-to-dollar-course';
import { PHONE_BUTTON_POPUP_NAME } from '@/components/general/PhoneButton/PhoneButton';
import classNames from 'classnames';
import { forwardRef } from 'react';

const NavFiltersInner = forwardRef<HTMLDivElement>((props, ref) => {
    const setServiceValueFormState = useSetSelectedServiceValueFormState();
    const setFeedbackPopupDataName = useSetFeedbackPopupDataNameState();
    const { openPopup } = useSetOpenedPopupsState();
    const [navData] = useNavProductDataState();
    const [course] = useRoubleToDollarCourseState();
    const [euroCourse] = useEuroToDollarCourseState();

    const hasPrice = !!navData.price && Number(navData.price) !== 0;
    const isAvailable = !!navData.available && Number(navData.available) !== 0;

    const prices = hasPrice
        ? [
              toCurrency(navData.price, 'USD'),
              toCurrency(navData.price * course, 'RUB'),
              toCurrency(navData.price * euroCourse, 'EUR'),
          ]
        : [];
    const setSelectedItems = useSetSelectedItemsState();

    return (
        <div className="filter-inner" ref={ref}>
            <div className="filter-inner__left">
                <Button variant="primary" className="filter-inner__btn-left" tag={Link} href="/" size="sm">
                    <span className="filter-inner__btn-img filter-inner__btn-img--main"></span>
                    Главная
                </Button>
                <Button variant="primary" className="filter-inner__btn-left" tag={Link} href="/new-products" size="sm">
                    <span className="filter-inner__btn-img filter-inner__btn-img--new-products"></span>
                    Новинки
                </Button>
                <Button variant="primary" className="filter-inner__btn-left" size="sm" tag={Link} href={'/catalog'}>
                    <span className="filter-inner__btn-img filter-inner__btn-img--catalog"></span>
                    Каталог
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__btn-left"
                    size="sm"
                    onClick={() => {
                        setServiceValueFormState('продать');
                        setFeedbackPopupDataName('sell');
                        openPopup(FEEDBACK_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_request');
                    }}
                >
                    <span className="filter-inner__btn-img filter-inner__btn-img--sell"></span>
                    Продать
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__btn-left"
                    size="sm"
                    onClick={() => {
                        setServiceValueFormState('консьерж');
                        setFeedbackPopupDataName('concierge');
                        openPopup(FEEDBACK_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_request');
                    }}
                >
                    <span className="filter-inner__btn-img filter-inner__btn-img--concierge"></span>
                    Консьерж
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__btn-left"
                    size="sm"
                    onClick={() => {
                        openPopup(FAVORITES_POPUP_NAME);
                    }}
                >
                    <span className="filter-inner__btn-img filter-inner__btn-img--favourites"></span>
                    Избранное
                </Button>
            </div>
            <div
                className={classNames('filter-inner__right', {
                    'filter-inner__right--no-price': !hasPrice,
                })}
            >
                {isAvailable && hasPrice && (
                    <>
                        <CurrencyDropdown prices={prices} classname="filter-inner__dropdown" />
                        <Button
                            className="filter-inner__buy"
                            variant="primary"
                            onClick={() => {
                                setServiceValueFormState('Купить');
                                setSelectedItems([navData.title]);
                                setFeedbackPopupDataName('empty');
                                openPopup(FEEDBACK_POPUP_NAME);
                                window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_buy_button');
                            }}
                        >
                            Купить
                        </Button>
                    </>
                )}

                {!isAvailable && hasPrice && (
                    <div className="filter-inner__order">
                        <Button
                            variant="primary"
                            className="filter-inner__order-btn"
                            onClick={() => {
                                setServiceValueFormState('Под заказ');
                                setSelectedItems([navData.title]);
                                setFeedbackPopupDataName('order');
                                openPopup(FEEDBACK_POPUP_NAME);
                                window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_buy_button');
                            }}
                        >
                            Под заказ
                        </Button>

                        <Button
                            variant="primary"
                            className="filter-inner__buy"
                            onClick={() => {
                                setServiceValueFormState('Купить');
                                setSelectedItems([navData.title]);
                                setFeedbackPopupDataName('empty');
                                openPopup(FEEDBACK_POPUP_NAME);
                                window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_buy_button');
                            }}
                        >
                            Купить
                        </Button>
                    </div>
                )}

                <Button
                    tag={Link}
                    href="/viewed"
                    variant="primary"
                    className="filter-inner__right-btn filter-inner__right-btn--viewed"
                    aria-label="перейти к просматриваемым"
                >
                    <span className="filter-inner__btn-right-img filter-inner__btn-right-img--animate">
                        <svg
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                            className="viewed-icon"
                        >
                            <path
                                d="M2.72842 12.7466C2.02015 11.8264 1.66602 11.3663 1.66602 10.0002C1.66602 8.634 2.02015 8.17394 2.72842 7.25377C4.14265 5.41646 6.51444 3.3335 9.99935 3.3335C13.4843 3.3335 15.856 5.41646 17.2703 7.25377C17.9785 8.17394 18.3327 8.634 18.3327 10.0002C18.3327 11.3663 17.9785 11.8264 17.2703 12.7466C15.856 14.5838 13.4843 16.6668 9.99935 16.6668C6.51444 16.6668 4.14265 14.5838 2.72842 12.7466Z"
                                stroke="currentColor"
                            />
                            <path
                                className="viewed-icon__inner"
                                d="M12.4993 10.0002C12.4993 11.3809 11.3801 12.5002 9.99935 12.5002C8.6186 12.5002 7.49935 11.3809 7.49935 10.0002C7.49935 8.61941 8.6186 7.50016 9.99935 7.50016C11.3801 7.50016 12.4993 8.61941 12.4993 10.0002Z"
                                stroke="currentColor"
                            />
                        </svg>
                    </span>
                </Button>
                <Button
                    tag={Link}
                    href="/compare"
                    variant="primary"
                    className="filter-inner__right-btn filter-inner__right-btn--compare"
                    aria-label="перейти к cравнению"
                >
                    <span className="filter-inner__btn-right-img filter-inner__btn-img--compare"></span>
                </Button>

                <Button
                    variant="primary"
                    className="filter-inner__sort"
                    onClick={() => openPopup(SORT_POPUP_NAME)}
                    size="sm"
                    icon={<img src={SortSVG} className="img-fluid" alt="" decoding="async" />}
                >
                    Сортировка
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__filter"
                    onClick={() => openPopup(FILTERS_POPUP_NAME)}
                    size="sm"
                    icon={<img src={FilterSVG} className="img-fluid" alt="" decoding="async" />}
                >
                    Фильтр
                </Button>
                <Button
                    variant="primary"
                    className="filter-inner__right-btn filter-inner__right-btn--feedback"
                    size="sm"
                    aria-label="Форма обратной связи"
                    onClick={() => {
                        openPopup(PHONE_BUTTON_POPUP_NAME);
                        window.ym?.(YD_NEW_ID, 'reachGoal', 'click_on_the_phone');
                    }}
                >
                    <span className="filter-inner__btn-right-img filter-inner__btn-img--phone"></span>
                </Button>
            </div>
        </div>
    );
});

NavFiltersInner.displayName = 'NavFiltersInner';

export default NavFiltersInner;
